(() => {
 const slot=document.querySelector('.wa-footer-locale');
 if(!slot||slot.dataset.ready)return;
 slot.dataset.ready='true';
 const trigger=slot.querySelector('button');
 let active, original;
 const instance=()=>window._transtore?.switchers?.find(item=>item.button?.closest('.site-header')&&item.expand);
 const ready=setInterval(()=>{if(instance()){trigger.disabled=false;clearInterval(ready)}},250);
 setTimeout(()=>clearInterval(ready),20000);
 // Use Transtore's existing popup and settings handlers with the footer as its anchor.
 const restore=()=>{if(!active)return;active.toggleActive(false);active.buttonEl=original;active=null;trigger.setAttribute('aria-expanded','false')};
 trigger.addEventListener('click',event=>{
  event.stopPropagation();
  if(active){restore();return}
  active=instance();if(!active)return;
  active.toggleActive(false);
  original=active.buttonEl;active.buttonEl=trigger;active.toggleActive(true);
 });
 document.addEventListener('click',event=>{if(active&&!slot.contains(event.target)&&!active.expand.contains(event.target))restore()},true);
 new MutationObserver(()=>{if(active&&!trigger.classList.contains('ts-dropdown-btn__open'))restore()}).observe(trigger,{attributes:true,attributeFilter:['class']});
 document.addEventListener('keydown',event=>{if(event.key==='Escape'&&active){restore();trigger.focus({preventScroll:true})}});
})();
